import type { GameInstanceConfig, GamePlugin, RoundContext } from '../types';
import { computeQuota } from '@/lib/games/formats/quota';
import { balanceNetOwed } from '@/lib/games/formats/balance';
import {
  applyMoneyToNetOwed,
  getMoneyAmount,
  getStakeConfig,
  pointsFromTotals,
} from '../stakes-helpers';

export const quotaPlugin: GamePlugin = {
  id: 'quota',
  label: 'Quota',
  description: 'Beat your handicap target',
  requiresTeams: false,
  minPlayers: 2,
  defaultStakes: { scoringType: 'points' },
  compute(ctx: RoundContext, _config: GameInstanceConfig) {
    const stake = getStakeConfig(ctx.stakes, 'quota');
    const { rows, totals } = computeQuota(ctx);
    const keys = ctx.players.map((p) => p.playerKey);
    const pointVals = keys.map((k) => totals[k] || 0);
    const netOwed = applyMoneyToNetOwed(
      balanceNetOwed(keys, pointVals, getMoneyAmount(stake)),
      stake,
    );
    const leader = rows[0];
    return {
      formatId: 'quota',
      label: 'Quota',
      summary: leader ? `${leader.name} ${leader.over} over quota` : 'Enter scores',
      standings: rows.map((r, i) => ({
        playerKey: r.playerKey,
        name: r.name,
        value: `${r.over} (${r.quota} quota)`,
        rank: i + 1,
      })),
      netOwed,
      pointsAwarded: pointsFromTotals(keys, totals, stake),
      winners: leader ? [leader.playerKey] : [],
    };
  },
};
